
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  CircularProgress,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  DialogContentText
} from "@mui/material";
import { updateCashier } from "../../../../../services/Settings/Cashier";
import { getPrintersByBranch } from "../../../../../services/Settings/printers";
import { fetchAuthRoots } from "../../../../../services/apiService";

const EditCashierForm = ({ cashier, onClose, onSuccess }) => {
  const [form, setForm] = useState({ ...cashier });
  const [branches, setBranches] = useState([]);
  const [printers, setPrinters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const branchesRes = await fetchAuthRoots();
        setBranches(branchesRes);

        if (cashier.root_id) {
          const printersRes = await getPrintersByBranch(cashier.root_id);
          setPrinters(printersRes);
        }
      } catch (err) {
        setMessage("❌ فشل في تحميل البيانات.");
      }
    };
    loadInitialData();
  }, [cashier]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (name === "root_id") {
      try {
        const printersRes = await getPrintersByBranch(value);
        setPrinters(printersRes);
      } catch (err) {
        setPrinters([]);
      }
    }
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
        const payload = {
          id: parseInt(form.id, 10),
          name: form.name,
          printer_id: parseInt(form.printer_id, 10),
          root_id: parseInt(form.root_id, 10),
        };
      
        console.log("🚀 البيانات المرسلة لـ updateCashier:", payload);
        const response = await updateCashier(payload);
      
        setMessage(`✅ تم تعديل بيانات الكاشير "${form.name}" بنجاح!`);
        if (onSuccess) onSuccess();
        onClose();
      } catch (err) {
        console.error("❌ خطأ أثناء حفظ الكاشير:", err);
        setMessage("❌ حدث خطأ أثناء تعديل الكاشير.");
      }
      
  };
  

  return (
    <>
      <Dialog open onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle>✏️ تعديل بيانات الكاشير</DialogTitle>
        <DialogContent>
          <TextField
            label="اسم الكاشير"
            name="name"
            value={form.name}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>اختر الفرع</InputLabel>
            <Select name="root_id" value={form.root_id} onChange={handleChange}>
              {branches.map((branch) => (
                <MenuItem key={branch.id} value={branch.id}>
                  {branch.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth margin="normal">
            <InputLabel>اختر الطابعة</InputLabel>
            <Select name="printer_id" value={form.printer_id} onChange={handleChange}>
              {printers.map((printer) => (
                <MenuItem key={printer.id} value={printer.id}>
                  {printer.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">إلغاء</Button>
          <Button onClick={() => setConfirmDialogOpen(true)} variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={24} /> : "حفظ التعديلات"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDialogOpen} onClose={() => setConfirmDialogOpen(false)}>
        <DialogTitle>تأكيد التعديل</DialogTitle>
        <DialogContent>
          <DialogContentText>
            هل أنت متأكد أنك تريد حفظ التعديلات للكاشير "{form.name}"؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDialogOpen(false)} color="secondary">
            إلغاء
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!message}
        autoHideDuration={4000}
        onClose={() => setMessage("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={message.startsWith("✅") ? "success" : "error"}>{message}</Alert>
      </Snackbar>
    </>
  );
};

export default EditCashierForm;
